var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"itemContainer",attrs:{"role":"radiogroup","aria-labelledby":_vm.label}},[_vm._t("default",[_vm._v("This is single select slot")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }